import { z } from "zod"

export const pilotTrackingTagRecordSchema = z.object({
    id: z.string(),
    name: z.string(),
    org_id: z.string(),
})

export const pilotTrackingTagSchema = pilotTrackingTagRecordSchema.transform((r) => ({
    id: r.id,
    name: r.name,
    orgId: r.org_id,
}))

const pilotTrackingTagMissionOperationSchema = z.enum(["tag", "untag"])

export const pilotTrackingTagMissionSpecSchema = z.object({
    tagId: z.string(),
    missionId: z.string(),
})

export const pilotTrackingBatchTagMissionSpecSchema = pilotTrackingTagMissionSpecSchema.extend({
    operation: pilotTrackingTagMissionOperationSchema,
})

export const updatablePilotTrackingTagSchema = z.object({ name: z.string().min(1) })

export type UpdatablePilotTrackingTag = z.infer<typeof updatablePilotTrackingTagSchema>
export type PilotTrackingTagRecord = z.infer<typeof pilotTrackingTagRecordSchema>
export type PilotTrackingTag = z.infer<typeof pilotTrackingTagSchema>
export type CreatablePilotTrackingTag = Omit<PilotTrackingTag, "id">
export type PilotTrackingTagMissionSpec = z.infer<typeof pilotTrackingTagMissionSpecSchema>
export type PilotTrackingBatchTagMissionSpec = z.infer<
    typeof pilotTrackingBatchTagMissionSpecSchema
>
